"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Analytics } from "../../../../../Analytics/index.js";
import { ONE, KEY_SEARCH_CLICK } from "../../../../../Analytics/constants.js";
import { AddToList } from "../../../../AddToList/index.js";
import { getFormattedPrice } from "../PriceGroup/Price/lib.js";
import { childElementStyles } from "../styles.js";
import { useProductTileData } from "../../../../../../hooks/useProductTileData/index.js";
import { ProductDeliveryBadge } from "./ProductDeliveryBadge/index.js";
import { containerStyles } from "./styles.js";
const ProductDeliveryBadgeAddtoList = ({
  showActionButton
}) => {
  const { normalizedData, productTitleId, locale, translationsConfig } = useProductTileData();
  const { hideAddToList } = (translationsConfig == null ? void 0 : translationsConfig.featureControls) || {};
  const { productDeliveryBadgeData, addToListButtonData, productInfoData } = normalizedData;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": `ProductDeliveryBadge_${productInfoData.partNumber}`,
      sx: containerStyles,
      children: [
        productDeliveryBadgeData && /* @__PURE__ */ jsx(
          Analytics,
          {
            analyticData: {
              trackedData: [{ key: KEY_SEARCH_CLICK, value: ONE }]
            },
            children: /* @__PURE__ */ jsx(ProductDeliveryBadge, {})
          }
        ),
        showActionButton && addToListButtonData && !hideAddToList && /* @__PURE__ */ jsx(Analytics, { analyticData: { doNotTrack: true }, children: /* @__PURE__ */ jsx(
          AddToList,
          {
            product: (
              // TODO: optional - send isMembershipOnlyItem
              {
                href: productInfoData.productLinkUrl,
                id: productInfoData.itemNumber,
                price: getFormattedPrice(
                  locale,
                  addToListButtonData.price
                ),
                src: productInfoData.productImageUrl,
                title: productInfoData.productName
              }
            ),
            ariaDescribedBy: productTitleId,
            sx: childElementStyles,
            uniqueId: `AddToList_${productInfoData.partNumber}`
          }
        ) })
      ]
    }
  );
};
export {
  ProductDeliveryBadgeAddtoList
};
